<!-- FIXME(Matt): We should remove lang: 'en|static' -->
<accredible-base-header *transloco="let t; lang: 'en|static' read: 'credentialdirectory_sage_com.header'">

  <div identitySection>
    <img
      [alt]="t('sage_logo')"
      class="branding-logo"
      src="assets/themes/credentialdirectory.sage.com/images/header_logo.png">
  </div>

  <div navigationSection>
    <sl-header-menu [enableDirectoriesLink]="true"></sl-header-menu>
  </div>
</accredible-base-header>
